import { FC, PropsWithChildren } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { MembershipWithOrganizationTypeEnum } from '@/api/rest/resources/types/membership';
import { useUser } from '@/lib/auth';
import { paths } from '@/routing';
import { RequireAuth } from '@/routing/components/protections/require-auth/RequireAuth';
import { RequireOnboarding } from '@/routing/components/protections/require-onboarding/RequireOnboarding';

export const LandStewardSignedInRoute: FC = () => {
  return (
    <RequireAuth>
      <RequireLandStewardRole>
        <RequireOnboarding>
          <Outlet />
        </RequireOnboarding>
      </RequireLandStewardRole>
    </RequireAuth>
  );
};

const RequireLandStewardRole: FC<PropsWithChildren> = ({ children }) => {
  const user = useUser();
  const isStaff = user.is_staff;

  const userType = user.membership.type;

  if (userType === MembershipWithOrganizationTypeEnum.buyer) {
    return <Navigate to={paths.buyer.restrictedAccess} replace />;
  }

  if (userType !== MembershipWithOrganizationTypeEnum.land_steward && !isStaff)
    throw new Error(
      `Expected "${MembershipWithOrganizationTypeEnum.land_steward}", but got invalid user type "${userType}"`,
    );

  return <>{children}</>;
};
